import React, { useEffect, useState } from "react";
import { AppBar, Toolbar, Typography, IconButton, Box } from "@mui/material";
import { Avatar } from "primereact/avatar";

import MenuIcon from "@mui/icons-material/Menu";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import { styled } from "@mui/material/styles";
import "./MainMenu.scss";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../auth/authConfig";

import axios from "axios";
import { FaUser } from "react-icons/fa";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
const drawerWidth = 240;

// Styled AppBar that adapts to the drawer state
const StyledAppBar = styled(AppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  backgroundColor: "white",
  borderBottom: "1px solid #E5E7EB",
  boxShadow: "none",
  marginLeft: open ? drawerWidth : 80, // <-- Here marginLeft is 240 if open, else 80
  width: open ? `calc(100% - ${drawerWidth}px)` : `calc(100% - 65px)`, // adjust width accordingly
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
}));

const MainHeader = ({ open, handleDrawerOpen, text, text2 }) => {
  const { accounts, instance } = useMsal();
  const account = accounts?.[0];
  const name = account?.name || "User";
  const email = account?.username || "user@aaysinsight.com";
  const [photo, setPhoto] = useState(localStorage.getItem("profilePhoto") || null);
  const [anchorEl, setAnchorEl] = useState(null); // anchor element for menu
  const [userRole, setUserRole] = useState("");

  const getProfilePhoto = async () => {
    try {
      // Ensure you acquire a token for the signed-in user
      const response = await instance.acquireTokenSilent({
        ...loginRequest,
        account: accounts[0], // Use the first account from the authenticated accounts
      });

      const token = response.accessToken;

      // Fetch the profile photo
      const photoResponse = await axios.get(
        "https://graph.microsoft.com/v1.0/me/photo/$value",
        {
          headers: {
            Authorization: `Bearer ${token}`, // Pass the token in the Authorization header
          },
          responseType: "arraybuffer", // To receive the image as binary data
        }
      );

      const blob = new Blob([photoResponse.data], { type: "image/jpeg" });
      const imageUrl = URL.createObjectURL(blob);
      setPhoto(imageUrl);
     
    } catch (err) {
      console.error("Error fetching profile photo", err);
    }
  };

  const handleAvatarClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };


  useEffect(() => {
    // getProfilePhoto();
  }, []);
  console.log("photo Details:", photo);
  return (
    <StyledAppBar sx={{justifyContent:"center", background:"#fff"}} position="fixed" open={open}>
      <Toolbar >
        {/* Hamburger menu only shown when drawer is closed */}
        {!open && (
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={{ mr: 2 }}
          >
            <MenuIcon sx={{ color: "#bb1ccc" }} />
          </IconButton>
        )}

        {/* Title */}
        <Typography
          className="menuHeader"
          sx={{ color: "white", fontSize: "20px", fontWeight: "600", display: "flex", alignItems: "center", gap: "10px" }}
          variant="h6"
          noWrap
          component="div"
        >
         <span style={{color:"#bb1ccc"}}> {text}</span> 
          <span> {text2 && <ArrowForwardIosIcon sx={{ color: "#bb1ccc", fontSize: "30px" }} />}</span> 
          {text2 && <Typography sx={{ color: "#bb1ccc", fontSize: "20px", fontWeight: "600",fontFamily: "'Poppins', sans-serif", }} variant="h6" noWrap component="div">
            {text2}
          </Typography>}
        </Typography>

        {/* Spacer */}
        <Box sx={{ flexGrow: 1 }} />

        {/* Icons section */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            alignContent: "center",
            
          }}
        >
          <IconButton>
            <NotificationsNoneIcon sx={{ color: "white", fontSize: "28px" }} />
          </IconButton>
          {/* <div className="flex items-center gap-2 border-l border-white pl-4 h-[24px]">

          <Avatar
            image={photo ? photo : null}
            data-pr-tooltip={name || "User"}
            style={{
              verticalAlign: "top",
              position: "relative",
              backgroundColor: "white",
              color: "black",
              fontWeight: "bold",
              height: "35px",
              width: "35px",
            }}
            onClick={handleAvatarClick}
            shape="circle"
          >
            {photo ? "" : name?.charAt(0).toUpperCase() || 'U'}
          </Avatar>
          <p className="text-[#bb1ccc] font-poppins font-normal" >{name ? name : ""}</p>
          </div> */}
<div className="flex items-center justify-between gap-1 w-full px-3 py-2">
  <div className="flex flex-col gap-[2px]">
    <p className="text-[#bb1ccc] font-poppins font-medium text-[15px] ">
      {name || "Aays"}
    </p>
    <p className="text-[#bb1ccc] font-poppins text-[12px] ">
      {email || "aays"}
    </p>
  </div>

  <div
    className="flex items-center justify-center rounded-full bg-[#bb1ccc] text-white font-semibold text-sm w-[35px] h-[35px]"
    onClick={handleAvatarClick}
  >
    {name
      ? name
          .split(" ")
          .map((word) => word[0])
          .join("")
          .toUpperCase()
      : "AA"}
  </div>
</div>


        </Box>
      </Toolbar>
    </StyledAppBar>
  );
};

export default MainHeader;
